import PT from 'prop-types';

export const CategoryType = PT.shape({
	id: PT.string.isRequired,
	title: PT.string.isRequired,
	items: PT.arrayOf(PT.string),
	order: PT.number.isRequired,
});

export const CategoriesType = PT.shape({
	podcasts: CategoryType,
});
